import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { tv } from "tailwind-variants";
import { Drawer as DrawerPrimitive } from "vaul";
import Icon from "../../icons";
import { cn } from "../../utils";
import Button from "../Button";
import Divider from "../Divider";
import Typography from "../Typography";
const drawerVariants = tv({
    base: "flex flex-col gap-1 fixed right-0 top-0 bg-white rounded-xl overflow-hidden h-[calc(100%-16px)] shadow-drawer z-drawer m-2 box-border",
    variants: {
        size: {
            sm: "drawer-sm",
            md: "drawer-md",
            lg: "drawer-lg",
        },
    },
    defaultVariants: {
        size: "md",
    },
});
const Drawer = ({ shouldScaleBackground = true, direction = "right", ...props }) => (_jsx(DrawerPrimitive.Root, { shouldScaleBackground: shouldScaleBackground, direction: direction, ...props }));
Drawer.displayName = "Drawer";
const DrawerTrigger = DrawerPrimitive.Trigger;
const DrawerPortal = DrawerPrimitive.Portal;
const DrawerClose = React.forwardRef((props, ref) => {
    if (props.asChild)
        return (_jsx(DrawerPrimitive.Close, { ref: ref, ...props, children: props.children }));
    return (_jsx(DrawerPrimitive.Close, { "data-testid": "drawer-close", ...props, asChild: true, children: _jsx(Button, { "aria-label": "Close", icon: _jsx(Icon, { name: "x" }), variant: "link", color: "default" }) }));
});
DrawerClose.displayName = "DrawerClose";
const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => _jsx(DrawerPrimitive.Overlay, { ref: ref, className: cn("fixed inset-0 z-drawer bg-gray-a8 backdrop-blur-sm", className), ...props }));
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;
const DrawerContent = React.forwardRef(({ className, children, size, ...props }, ref) => (_jsxs(DrawerPortal, { children: [_jsx(DrawerOverlay, {}), _jsx(DrawerPrimitive.Content, { ref: ref, className: cn(drawerVariants({ size }), className), ...props, children: children })] })));
DrawerContent.displayName = "DrawerContent";
const DrawerHeader = ({ className, children, ...props }) => (_jsxs("div", { className: cn("mt-5 flex flex-col gap-2 px-5", className), ...props, children: [_jsx("div", { className: "flex items-center justify-between", children: children }), _jsx(Divider, {})] }));
DrawerHeader.displayName = "DrawerHeader";
const DrawerFooter = ({ className, ...props }) => (_jsx("div", { className: cn("bottom-0 mt-auto flex w-full gap-2 border-gray-light border-t bg-white p-5", className), ...props }));
DrawerFooter.displayName = "DrawerFooter";
const DrawerTitle = React.forwardRef(({ className, children, ...props }, ref) => (_jsx(DrawerPrimitive.Title, { ref: ref, className: className, ...props, children: _jsx(Typography, { variant: "heading-1", children: children }) })));
DrawerTitle.displayName = DrawerPrimitive.Title.displayName;
const DrawerBody = React.forwardRef(({ className, children, ...props }, ref) => (_jsx(DrawerPrimitive.Description, { ref: ref, ...props, asChild: true, children: _jsx("div", { className: cn("flex w-full overflow-auto px-5 py-2", className), children: children }) })));
DrawerBody.displayName = DrawerPrimitive.Description.displayName;
export default Drawer;
export { DrawerPortal, DrawerOverlay, DrawerTrigger, DrawerClose, DrawerContent, DrawerHeader, DrawerFooter, DrawerTitle, DrawerBody };
